import {
  EventTypesEnum,
  LessonTypesEnum,
  PlaySessionMatchCompetitivenessEnum,
  SportsEnum,
} from 'types/generated/client';

export type ActivityType = LessonTypesEnum | EventTypesEnum;

/**
 * A court booking is a reservation against a club's inventory, not a hosted
 * activity, so it has no row in events/lessons and no enum of its own. It is a
 * badge label, not an `ActivityType` — callers like `getDefaultActivityImage`
 * only ever deal in real activities.
 */
export const COURT_BOOKING_TYPE = 'COURT_BOOKING';

export type ActivityBadgeType = ActivityType | typeof COURT_BOOKING_TYPE;

export interface ActivityBadgeProps {
  type: ActivityBadgeType;
  sport?: SportsEnum | null;
  size?: 'xs' | 'sm' | 'md';
  /** Steps the badge up at `lg`, mirroring Button's size/sizeDesktop pair. */
  sizeDesktop?: 'xs' | 'sm' | 'md';
  className?: string;
  /**
   * Play-session competitiveness. When set it replaces BOTH the type label and
   * the colour — e.g. "Tennis Competitive" (purple) instead of "Tennis Open Play".
   * Games are differentiated by how competitive they are, not by activity type.
   */
  competitiveness?: PlaySessionMatchCompetitivenessEnum | null;
  /** An RFX class is a GENERAL_EVENT row flagged `is_rfx`; the badge names the brand. */
  isRfx?: boolean | null;
}
